import { IDraftsTableColumns, IResumessTableColumns } from "@/lib/interfaces";

export const VDraftsTableColumns: IResumessTableColumns = {
    "date": "Created On",
    "title": "Title",
    "snippet": "Draft",
    "id": "ID"
}

export enum TDraftElementsCategory {
    CARD,
    FULL
}

export const VResumesTableColumns: IDraftsTableColumns = {
    "date": "Created On",
    "role": "Role"
}
